module.exports = __webpack_public_path__ + "media/images/home/main/aa/3-337332e463d9c7db3094839ba75929a1.png";